import React, { FunctionComponent } from 'react'
import { Link } from "react-router-dom"
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import style from "./Overview.scss"
import { Limb } from '../Limb'

interface IProps {
    customerId: string,
    limb: Limb
}

const SkinTrack: FunctionComponent<IProps> = ({customerId, limb}) => {
    const {t} = useTranslation()
    let classes = classNames({
        [style.skinTrackBlock]: true,
        [style.active]: true
    })

    const url = '/customers/' + customerId + '/skin-track/' + limb

    return (
        <Link className={classes} to={url}>
            {t(limb)}
        </Link>
    )
}

export default SkinTrack
